<template>
  <van-popup
    v-model="show"
    round
    position="bottom"
    class="popup"
    @closed="close"
  >
    <div class="main main-fixed">
      <div class="title">
        待取件<span>{{ `(${list.length})` }}</span>
      </div>
      <div class="all-box" @click="checkAll">
        <div class="font-14" style="flex:1;padding-right:10px">全选</div>
        <div><van-checkbox v-model="allChecked" checked-color="#a30014" /></div>
      </div>
    </div>

    <div class="check-box">
      <div
        class="box"
        v-for="(item, index) in list"
        :key="item.expressId"
        @click="toggle(item)"
        :style="index === list.length - 1 ? 'margin-bottom:70px' : ''"
      >
        <div>
          <van-image width="30" height="30" :src="item.companyImg" />
        </div>
        <div class="text">
          <div class="code">
            {{ item.discernCode ? item.discernCode : item.pickupCode }}
          </div>
          <div>{{ item.customerPhone }}的快递</div>
        </div>
        <van-checkbox v-model="item.checked" checked-color="#a30014" />
      </div>
    </div>
    <div class="oneClick">
      <van-button color="#a30014" size="small" class="btn" @click="all"
        >全部取出 {{ '(' + selectedSum + ')' }}</van-button
      >
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    list: Array,
    siteId: String
  },
  data() {
    return {
      show: false,
      allChecked: false,
      // expressList: [1, 1, 1, 1, 1, 1, 1, 2, 3],
      result: []
    }
  },
  created() {
    // console.log(this.list)
    for (let i of this.list) {
      this.$set(i, 'checked', false)
    }
    this.checkAll()
  },
  watch: {},
  computed: {
    selectedSum() {
      let a = 0
      for (let i of this.list) {
        if (i.checked) {
          a++
        }
      }
      return a
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    toggle(item) {
      item.checked = !item.checked
      let flag = false
      for (let i of this.list) {
        if (!i.checked) {
          flag = true
          break
        }
      }
      if (flag) {
        this.allChecked = false
      } else {
        this.allChecked = true
      }
    },
    checkAll() {
      this.allChecked = !this.allChecked
      if (this.allChecked) {
        for (let i of this.list) {
          i.checked = true
        }
      } else {
        for (let i of this.list) {
          i.checked = false
        }
      }
    },
    all() {
      let array = []
      for (let i of this.list) {
        if (i.checked) {
          array.push(i.expressId)
        }
      }
      if (array.length === 0) {
        this.$toast.fail('请选择快递')
        return
      }
      let obj = JSON.parse(localStorage.getItem('userInfo'))
      let phone = this.$route.query.mobile
      let params = {
        appId: obj.appId,
        openId: obj.openId,
        waiteHandleExpresses: [
          {
            expressIds: array,
            siteId: this.siteId
          }
        ],
        phone
      }
      // let params = {
      //   appId: 'wx0a3c5448c56895a2',
      //   openId: 'oP-g4v1ui8AdP3YOUdhtP9uhcJ7U',
      //   waiteHandleExpresses: [
      //     {
      //       expressIds: array,
      //       siteId: this.siteId
      //     }
      //   ]
      // }
      // console.log(params)
      let data = this.$Base64.encode(JSON.stringify(params))
      this.$api.oneKeyPickUp(data).then(res => {
        if (res.code === 0) {
          this.$toast({
            message: '取件申请已提交',
            type: 'success',
            duration: 1000,
            forbidClick: true,
            onClose: () => {
              this.$emit('refresh')
              this.show = false
            }
          })
        }
      })
      // this.show = false
      // this.$toast.success('提交取件任务成功')
    }
  }
}
</script>
<style lang="scss" scoped>
.popup {
  // position: relative;
  height: 70%;
}
.main-fixed {
  position: sticky;
  top: 0px;
  background-color: #fff;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #d7d7d7;
}
.all-box {
  display: flex;
  align-items: center;
  // margin: 10px 0px 0 15px;
  // padding: 5px 15px;
}
.main {
  padding: 10px 15px;
}
.title {
  color: #a30014;
  font-size: 14px;
  margin-left: 15px;
  span {
    margin-left: 5px;
  }
}
.check-box {
  margin-left: 15px;
}
.box {
  display: flex;
  align-items: center;
  margin: 15px;
  .text {
    flex: 1;
    margin-left: 20px;
    .code {
      font-size: 16px;
      font-weight: 700;
    }
  }
}
.oneClick {
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  text-align: right;
  padding: 10px 10px;
  background-color: #fff;
  z-index: 1000;
  border-top: 1px solid #d7d7d7;
  .btn {
    padding: 0 25px;
    border-radius: 5px;
  }
}
</style>
